/** True when account type is a business/client owner. */
export function isBusinessAccountType(userType) {
  return String(userType || "").toLowerCase() === "business";
}

/** True when account type is a freelancer/applicant. */
export function isFreelancerAccountType(userType) {
  const t = String(userType || "").toLowerCase();
  return t === "freelancers" || t === "freelancer";
}

/** List page for accepted project workspaces (role-specific). */
export function getProposalListPath(userType) {
  return isBusinessAccountType(userType) ? "/project-proposals" : "/my-projects";
}

/** Detail workspace URL for one proposal/applicant row (uses order_code when available). */
export function getProposalWorkspacePath(proposalOrRef, userType) {
  const base = getProposalListPath(userType);
  const ref =
    typeof proposalOrRef === "object" && proposalOrRef !== null
      ? proposalOrRef.order_code || proposalOrRef.id
      : proposalOrRef;
  if (ref == null || ref === "") return base;
  return `${base}/${encodeURIComponent(String(ref))}`;
}

/** Filter project-proposals list by project code. */
export function getProjectProposalsFilterPath(projectOrRef, projectName) {
  const code =
    typeof projectOrRef === "object" && projectOrRef !== null
      ? projectOrRef.project_code || projectOrRef.id
      : projectOrRef;
  if (code == null || code === "") return "/project-proposals";
  const params = new URLSearchParams({ project: String(code) });
  return `/project-proposals?${params.toString()}`;
}

/** Normalize legacy / cross-role workspace links to the correct route. */
export function normalizeProposalWorkspacePath(pathname, userType) {
  const path = String(pathname || "");
  const listPath = getProposalListPath(userType);
  const isBusiness = isBusinessAccountType(userType);

  if (isBusiness && path.startsWith("/my-projects")) {
    const id = path.match(/^\/my-projects\/([^/]+)/)?.[1];
    return id ? `${listPath}/${id}` : listPath;
  }

  if (!isBusiness && path.startsWith("/project-proposals")) {
    const id = path.match(/^\/project-proposals\/([^/]+)/)?.[1];
    return id ? `${listPath}/${id}` : listPath;
  }

  if (path.startsWith("/gig-proposals")) {
    const id = path.match(/^\/gig-proposals\/([^/]+)/)?.[1];
    return id ? `${listPath}/${id}` : listPath;
  }

  return path;
}
